import React from 'react'
import { Box } from '@chatterbug/aaron'
import { LeaderboardPosition } from 'src/types'
import RedactedUsers from '../RedactedUsers/RedactedUsers'
import LeaderboardRow from '../LeaderboardRow/LeaderboardRow'

export type Props = {
  topUsers: LeaderboardPosition[]
  orgSize: number
  currentUserPosition: LeaderboardPosition
}

const UserInTheMiddle: React.FC<Props> = ({
  topUsers,
  orgSize,
  currentUserPosition,
}) => {
  return (
    <Box>
      {topUsers?.map((item, index) => {
        return <LeaderboardRow key={`leaderboard-row-${index}`} {...item} />
      })}
      <Box mb="2x">
        <RedactedUsers redactedNum={currentUserPosition.rank - 4} />
      </Box>
      <LeaderboardRow {...currentUserPosition} isCurrentUser={true} />
    </Box>
  )
}

export default UserInTheMiddle
